<template>
  <div class="home">
    <div class="status_bar">
      <div>
        <img v-show="!isWeChat()" @click="backfn" src="@/assets/img/back.png" alt="" srcset="">
      </div>
      <div>
        <img v-show="!isWeChat()" @click="shareFn" src="@/assets/img/share.png" alt="" srcset="">
        <!-- <img class="rule_btn" @click="dialog_type = 1;show_dialog = true" src="@/assets/img/rule.png" alt="" srcset=""> -->
      </div>
    </div>
    <div class="mark_box">
      <img class="bg" src="@/assets/img/bg.png" alt="" srcset="">
      <div :class="['xhn_build',check(1)?'xhn_build_light':'']">
        <template v-if="!isWeChat()">
          <img v-if="!check(1)" class="xhn_build_img" src="@/assets/img/xhn_hui.png" alt="" srcset="">
          <img v-else class="xhn_build_img duang_animation" src="@/assets/img/xhn.png" alt="" srcset="">
        </template>
        <template v-else>
          <img  class="xhn_build_img" src="@/assets/img/xhn.png" alt="" srcset="">
        </template>
        <template v-if="!isWeChat()">
          <div @click="light_fn(1)" v-if="!check(1)" class="light_btn_body xhn_light_btn">
              <template v-if="point_num == 1">
                <div  class="ca_box"></div>
                <img class="light_btn" src="@/assets/img/light.png" alt="" srcset="">
              </template>
              <img v-else class="light_btn" src="@/assets/img/light_hui.png" alt="" srcset="">
          </div>
          <div  v-else class="join_btn_body xhn_join_btn">
            <!-- <div class="ca_box"></div> -->
            <img  class="join_btn" src="@/assets/img/lighted.png" alt="" srcset="">
          </div>
        </template>
      </div>
      <div :class="['why_build',check(2)?'why_build_light':'']">
        <template v-if="!isWeChat()">
          <img v-if="!check(2)" class="why_build_img" src="@/assets/img/martyr_tower_hui.png" alt="" srcset="">
          <img v-else class="why_build_img duang_animation" src="@/assets/img/martyr_tower.png" alt="" srcset="">
        </template>
        <template v-else>
          <img class="why_build_img" src="@/assets/img/martyr_tower.png" alt="" srcset="">
        </template>
        <!-- <template v-if="!isWeChat()">
          <div @click="light_fn(2)" v-if="!check(2)" class="light_btn_body">
              <template v-if="point_num == 2">
                <div  class="ca_box"></div>
                <img class="light_btn" src="@/assets/img/light.png" alt="" srcset="">
              </template>
              <img v-else class="light_btn" src="@/assets/img/light_hui.png" alt="" srcset="">
          </div>
          <div v-else class="join_btn_body">
            <img  class="join_btn" src="@/assets/img/lighted.png" alt="" srcset="">
          </div>
        </template> -->
      </div>
      <!-- 湖南国际会展中心 -->
      <!-- <div :class="['exhibition_build',check(3)?'exhibition_build_light':'']">
        <template v-if="!isWeChat()">
          <img v-if="!check(3)" class="exhibition_build_img" src="@/assets/img/exhibition_hui.png" alt="" srcset="">
          <img v-else class="exhibition_build_img duang_animation" src="@/assets/img/exhibition.png" alt="" srcset="">
        </template>
        <template v-else>
          <img  class="exhibition_build_img" src="@/assets/img/exhibition.png" alt="" srcset="">
        </template>
        <template v-if="!isWeChat()">
          <div @click="light_fn(3)" v-if="!check(3)" class="light_btn_body light_btn_exhibition">
              <template v-if="point_num == 3">
                <div  class="ca_box"></div>
                <img class="light_btn" src="@/assets/img/light.png" alt="" srcset="">
              </template>
              <img v-else class="light_btn" src="@/assets/img/light_hui.png" alt="" srcset="">
          </div>
          <div  v-else class="join_btn_body light_btn_exhibition">
            <img  class="join_btn" src="@/assets/img/lighted.png" alt="" srcset="">
          </div>
        </template>
      </div> -->
      <!-- 禁毒教育基地 -->
      <div v-if="false" :class="['grugs_build',check(4)?'grugs_build_light':'']">
        <template v-if="!isWeChat()">
          <img v-if="!check(4)" class="grugs_build_img" src="@/assets/img/grugs_hui.png" alt="" srcset="">
          <img v-else class="grugs_build_img duang_animation" src="@/assets/img/grugs.png" alt="" srcset="">
        </template>
        <template v-else>
          <img  class="grugs_build_img" src="@/assets/img/grugs.png" alt="" srcset="">
        </template>
        <template v-if="!isWeChat()">
          <div @click="light_fn(4)" v-if="!check(4)" class="light_btn_body light_btn_grugs">
              <template v-if="point_num == 4">
                <div  class="ca_box"></div>
                <img class="light_btn" src="@/assets/img/light.png" alt="" srcset="">
              </template>
              <img v-else class="light_btn" src="@/assets/img/light_hui.png" alt="" srcset="">
          </div>
          <div  v-else class="join_btn_body light_btn_grugs">
            <!-- <div class="ca_box"></div> -->
            <img  class="join_btn" src="@/assets/img/lighted.png" alt="" srcset="">
          </div>
        </template>
      </div>
      <!-- 隆平水稻博物馆 -->
      <div :class="['paddy_build',check(5)?'paddy_build_light':'']">
        <template v-if="!isWeChat()">
          <img v-if="!check(5)" class="paddy_build_img" src="@/assets/img/martyr_park_hui.png" alt="" srcset="">
          <img v-else class="paddy_build_img duang_animation" src="@/assets/img/martyr_park.png" alt="" srcset="">
        </template>
        <template v-else>
          <img  class="paddy_build_img" src="@/assets/img/martyr_park.png" alt="" srcset="">
        </template>
        <template v-if="!isWeChat()">
          <div @click="light_fn(5)" v-if="!check(5)" class="light_btn_body light_btn_paddy">
              <template v-if="point_num == 5">
                <div  class="ca_box"></div>
                <img class="light_btn" src="@/assets/img/light.png" alt="" srcset="">
              </template>
              <img v-else class="light_btn" src="@/assets/img/light_hui.png" alt="" srcset="">
          </div>
          <div  v-else class="join_btn_body light_btn_paddy">
            <img  class="join_btn" src="@/assets/img/lighted.png" alt="" srcset="">
          </div>
        </template>
      </div>
      <!-- (point_num == 1||point_num == 2)&&store.state.hasLogin?'point_body_animation':'' -->
      <div :class="['point_body',getpointclass(),(point_num == 1||point_num == 2||point_num == 3||point_num == 4||point_num == 5)&&store.state.hasLogin?'point_body_shan_animation':'']">
        <em></em>
        <div :class="['point_box']">
          <div>
            <img v-if="store.state.userinfo.photo" :src="store.state.userinfo.photo" alt="" srcset="">
            <img v-else src="@/assets/img/head.png" alt="" srcset="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 弹窗 -->
   <div v-if="show_dialog" class="dialog_mask">
    <div :class="['diloag_content',dialog_type==1?'':'diloag_content_small']">
      <i @click="show_dialog = false;clearTimeout()"></i>
      <div class="dialog_rule" v-if="dialog_type == 1">
        <h1>活动规则</h1>
        <p>1.活动目前支持的城市地标为新湖南大厦、长沙文和友（海信广场长沙店）、湖南国际会展中心、湖南(长沙)禁毒教育基地。在城市地标定位范围内，点击该地标“点亮”按钮可完成点亮</p>
        <p>2.同一地标，每人只可点亮一次</p>
        <p>3.点亮地标即可参与相关活动</p>
        <p>4.活动将陆续推出新城市地标，敬请期待</p>
        <p>5.最终解释权归新湖南所有</p>
      </div>
      <div v-if="dialog_type == 2" class="dialog_light">
        <p>很抱歉</p>
        <p>请在{{getTipsArea(dialog_area_num)}}200米内参与打卡活动 </p>
        <p>(手机需开启地理位置权限)</p>
        <div @click="show_dialog = false" class="know_btn"></div>
      </div>
      <div v-if="dialog_type == 3" class="dialog_goluck">
        <div>
          <p>恭喜您完成一个打卡任务</p>
          <!-- <p> 获得 <span>1</span> 次抽奖机会</p> -->
        </div>
        <!-- <div @click="toluck" class="luck_btn"></div> -->
      </div>
    </div>
   </div>
   <!-- 跳转按钮 -->
    <!-- <div v-if="!isWeChat()" @click="toluck" class="join_icon">
      <span v-if="store.state.hasLogin" >{{ luck_num }}</span>
    </div> -->
    <div v-if="isWeChat()" @click="todown" class="download_xhn">

    </div>
</template>

<script setup>
import {ref,onMounted} from 'vue'
import {useRoute} from 'vue-router'
import {useStore} from 'vuex'
import api from '@/api'
import $ from 'jquery'
import {showToast,showLoadingToast,closeToast } from 'vant'
const route = useRoute()
const shareFn = () =>{
  let post_data = {
      "share_title": "2026年职工线上健步走",
      "share_des": " ",
      "share_img": "",
      "share_url": location.href,
    }
    vmobile.beginShare(JSON.stringify(post_data))
}
//微信分享
var shareTitle = "2026年职工线上健步走";
var shareUrl = location.href;
var shareDesc = " ";
var shareImg = 'https://img2.voc.com.cn/2021/07/xhn/xhnlogo.png';
$.ajax({
      url:"https://cgi.voc.com.cn/api/weixin/xhn.php?url=" + encodeURIComponent(shareUrl),
      dataType: "json",
      success: function (data) {
        $.each(data, function (index, result) {
          if (result["status"] == 1) {
            var appId = result["appId"],
              timestamp = result["timestamp"],
              nonceStr = result["nonceStr"],
              signature = result["signature"];
            wx.config({
              debug: false,
              appId: appId,
              timestamp: timestamp,
              nonceStr: nonceStr,
              signature: signature,
              jsApiList: [
                "onMenuShareTimeline",
                "onMenuShareAppMessage",
                "onMenuShareQQ",
                "onMenuShareWeibo",
                "updateAppMessageShareData",
                "updateTimelineShareData",
              ],
              openTagList: ["wx-open-launch-app"],
            });
            wx.ready(function () {
              wx.updateAppMessageShareData({
                  title: shareTitle,
                  desc: shareDesc,
                  link: shareUrl,
                  imgUrl: shareImg,
              });
              wx.updateTimelineShareData({
                  title: shareTitle,
                  link: shareDesc,
                  imgUrl: shareImg,
              });
              wx.onMenuShareTimeline({
                  title: shareTitle,
                  desc: shareDesc,
                  link: shareUrl,
                  imgUrl: shareImg,
              });
              wx.onMenuShareWeibo({
                  title: shareTitle,
                  desc: shareDesc,
                  link: shareUrl,
                  imgUrl: shareImg,
              });
            });
            wx.error(function (res) {});
          }
        });
      },
    });


let barHeight = ref(0)
let point_num = ref(0)
let dialog_type = ref(1)
let show_dialog = ref(false)
let light_arr = ref([])
let dialog_time = ref({})
let dialog_area_num = ref(0)
const luck_num = ref(0)
const img_arr = [
  require('@/assets/img/xhn.png'),
  require('@/assets/img/why.png')
]
function preloadImages(imageArray) {
    imageArray.forEach(src => {
        const img = new Image();
        img.src = src;
    });
}
onMounted(()=>{
  console.log(route)
  if(route.query.rule){
    dialog_type.value = 1;
    show_dialog.value = true;
    dialog_time.value =  setTimeout(() => {
      show_dialog.value = false;
    },3000);
  }
})
const clearTimeout = () =>{
  clearInterval(dialog_time.value)
}
preloadImages(img_arr)
//vue
const store = useStore()
window['onload'] = () =>{
    if(vmobile.getLocationInfo){
      console.log('获取定位')
      vmobile.getLocationInfo()//获取定位信息
    }
    if(vmobile.getUserInfoForVote){
      vmobile.getUserInfoForVote();//隐式登录
    }
    var post_json = {
      "needStatusBar": true,//true 网页布局会延伸到状态栏
      "isLight": true,// true浅色背景，浅色时状态栏为黑色，false深色时状态栏为白色
      "isHideNav": true// true布局是延伸到底部虚拟按键
    } 
    vmobile.setEnableTopbar('false')
    vmobile.setImmersedStatusbar(JSON.stringify(post_json));
    window['setScreenInfo'] = (res) =>{
    let isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if(isIOS){
      barHeight.value = res.statusBarHeight;
    }else{
      barHeight.value = res.statusBarHeight/window.devicePixelRatio;
    }
  }
  }
  window['setUserInfoForVote'] = (res) =>{//隐式登录回调
      // if(this.userInfo.hasLogin){
      //   return;
      // }
      if(typeof(res) == 'string'){
        res = JSON.parse(res);
      }
      if(res.username == ''){
        return;
      }
      if(res.status != 1){
        return;
      }
      console.log(res)
      store.commit('set_userinfo',res)
      getdata()
    }
  window['setUserInfo'] = (res) =>{//强制登录回调
    if(typeof(res) == 'string'){
        res = JSON.parse(res);
      }
      if(res.username == ''){
        return;
      }
      if(res.status != 1){
        return;
      }
      console.log(res)
      store.commit('set_userinfo',res)
      getdata()
  }
  window['setLocationInfo'] = (e) =>{//获取定位信息回调
    console.log('定位回调',e,`新湖南大厦距离${(getDistance(e.longitude,e.latitude,112.991992,28.21286))}`)
    if(getDistance(e.longitude,e.latitude,112.991992,28.21286) <= 200){
      point_num.value = 1
    }
    // if(getDistance(e.longitude,e.latitude,112.999793,28.214549) <= 400){
    //   point_num.value = 2
    // }
    // if(getDistance(e.longitude,e.latitude,113.05598,28.240739) <= 400){
    //   point_num.value = 3
    // }
    // if(getDistance(e.longitude,e.latitude,113.011024,28.180282) <= 400){
    //   point_num.value = 4
    // }
    if(getDistance(e.longitude,e.latitude,113.010573,28.216674) <= 200){
      point_num.value = 5
    }
    console.log(point_num.value)
  }
  const check = (flag) =>{
    let check_str
    let val = false
    switch (flag) {
      case 1:
      check_str = '新湖南大厦'
        break;
      case 2:
      check_str = '烈士纪念塔'
        break;
      case 3:
      check_str = '湖南国际会展中心'
        break;
      case 4:
      check_str = '湖南(长沙)禁毒教育基地'
        break;
      case 5:
      check_str = '烈士公园阳光服务驿站'
        break;
      default:
        break;
    }
    light_arr.value.forEach((item)=>{
      if(item.type == check_str){
        val = true
      }
    })
    return val
  }
  const getTipsArea = (index)=>{
    let tip_str 
    switch (index) {
      case 1:
      tip_str = '新湖南大厦'
        break;
      case 2:
      tip_str = '烈士纪念塔'
        break;
      case 3:
      tip_str = '湖南国际会展中心'
        break;
      case 4:
      tip_str = '湖南(长沙)禁毒教育基地'
        break;
      case 5:
      tip_str = '烈士公园阳光服务驿站'
        break;
      default:
        break;
    }
    return tip_str
  }
  const toluck = () =>{
    if(isWeChat()){
      location.href = 'https://h5-xhncloud.voc.com.cn/xinhunan/?pkgname=com.dingtai.wxhn.activity&scheme='+encodeURIComponent(location.href)
      return;
    }
    vmobile.openUrl('','https://hudong.voc.com.cn/Lottery/index/index?activeid=41&appid=9')
  }
  function isWeChat() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
  }
  const todown = () =>{
    location.href = 'https://h5-xhncloud.voc.com.cn/xinhunan/?pkgname=com.dingtai.wxhn.activity&scheme='+encodeURIComponent(location.href)
  }
  const light_fn = (index) =>{
    if(isWeChat()){
      location.href = 'https://h5-xhncloud.voc.com.cn/xinhunan/?pkgname=com.dingtai.wxhn.activity&scheme='+encodeURIComponent(location.href)
      return;
    }
    if(!store.state.hasLogin){
      vmobile.getUserInfo()
      return ;
    }
    dialog_area_num.value = index
    if(!((point_num.value == 1&&index == 1)||(point_num.value == 2&&index == 2)||(point_num.value == 3&&index == 3)||(point_num.value == 4&&index == 4)||(point_num.value == 5&&index == 5))){
      show_dialog.value = true;
      dialog_type.value = 2;
      return;
    }
    let type_arr;
    switch (index) {
      case 1:
      type_arr = '新湖南大厦'
        break;
      case 2:
      type_arr = '烈士纪念塔'
        break;
      case 3:
      type_arr = '湖南国际会展中心'
        break;
      case 4:
      type_arr = '湖南(长沙)禁毒教育基地'
        break;
      case 5:
      type_arr = '烈士公园阳光服务驿站'
        break;
      default:
        break;
    }
    showLoadingToast({
      duration: 0,
      forbidClick: true,
    });
    let post_data = {
      appid:9,
      type:type_arr
    }
    api.lightup(post_data).then(res=>{
      closeToast()
      getdata()
      if(res.data.statecode == 1){
        setTimeout(() => {
          dialog_type.value = 3;
          show_dialog.value = true
        },1500);
      }else{
        showToast(res.data.message)
      }
    })
  }
  const getdata = () =>{
    api.get_lightlist().then(res=>{
        if(res.data.date&&res.data.date.length != 0){
          light_arr.value = res.data.date
        }
      })
      api.get_lucknum({activeid:41}).then(res=>{
        if(res.data.statecode == 1){
          luck_num.value = res.data.data.opportunity_nums
        }
      })
  }
  const backfn = () =>{
    vmobile.closePage();
  }
  const getpointclass = () =>{
    let classname = ''
    switch (point_num.value) {
      case 1:
      classname = 'xhn_point'
        break;
      case 2:
      classname = 'why_point'
        break;
      case 3:
      classname = 'exhibition_point'
        break;
      case 4:
      classname = 'grugs_point'
        break;
      case 5:
      classname = 'paddy_point'
        break;
      default:
        break;
    }
    return classname
  }
  const getDistance = (lat1,lng1,lat2,lng2)=> {
    function rad(d) {
      return d * Math.PI / 180.0; 
    }
      var radLat1 = rad(lat1);
      var radLat2 = rad(lat2);
      var a = radLat1 - radLat2;
      var b = rad(lng1) - rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * 6378.137; // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      
      var distance = s;
      var distance_str = "";
      
      distance_str = distance.toFixed(3) * 1000;
      
      //s=s.toFixed(4);
      
      return distance_str;
  }
  function calculateDistance(lat1, lon1, lat2, lon2) {
    // 将度数转换为弧度
    const toRadians = (degrees) => degrees * (Math.PI / 180);

    // 地球半径（单位：千米）
    const R = 6371;

    // 将经纬度从度数转换为弧度
    const lat1Rad = toRadians(lat1);
    const lon1Rad = toRadians(lon1);
    const lat2Rad = toRadians(lat2);
    const lon2Rad = toRadians(lon2);

    // 计算纬度差（y轴方向距离）
    const deltaLat = lat2Rad - lat1Rad;
    const deltaY = R * deltaLat;

    // 计算经度差（x轴方向距离），并根据平均纬度修正
    const deltaLon = lon2Rad - lon1Rad;
    const averageLat = (lat1Rad + lat2Rad) / 2;
    const deltaX = R * deltaLon * Math.cos(averageLat);

    return {
      deltaX: deltaX*1000, // x 轴方向（经度方向）的距离差（米）
      deltaY: deltaY*1000  // y 轴方向（纬度方向）的距离差（米）
    };
  }
</script>

<style lang="scss">
.download_xhn{
  width: 650px;
  height: 110px;
  background: url(~@/assets/img/down_xhn.png)no-repeat;
  background-size: 100% 100%;
  position: fixed;
  left: 50%;
  bottom: 109px;
  transform: translateX(-50%);
  z-index: 1;
}
.join_icon{
  width: 160px;
  height: 161px;
  position:fixed;
  left: 33px;
  bottom: 254px;
  background: url(~@/assets/img/join_btn.png)no-repeat;
  background-size: 100% 100%;
  span{
    width: 38px;
    height: 38px;
    background: #F56E39;
    border: 2px solid #FFF4D2;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 29px;
    color: #fff;
    right: 14px;
    top: 17px;
    font-weight: bold;
    border-radius: 100%;
    line-height: 1;
  }
}
.dialog_mask{
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .diloag_content{
    width: 624px;
    height: 931px;
    background: url(~@/assets/img/dialog.png)no-repeat;
    background-size: 100% 100%;
    position: relative;
    &.diloag_content_small{
      width: 624px;
      height: 528px;
      background: url(~@/assets/img/dialog_small.png)no-repeat;
      background-size: 100% 100%;
      position: relative;
    }
    &>i{
      position: absolute;
      width: 90px;
      height: 90px;
      right: 4px;
      top: -12px;
      background: url(~@/assets/img/close.png)no-repeat;
      background-size: 100% 100%;
    }
    .dialog_goluck{
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 154px 152px 102px 161px;
      justify-content: space-between;
      align-items: center;
      p{
        color: #3F1F07;
        font-size: 38px;
        line-height: 50px;
        white-space: nowrap;
        width: 100%;
        text-align: center;
        span{
          font-weight: bold;
          font-size: 58px;
          color: #FF731F;
          line-height: 76px;
        }
      }
      .luck_btn{
        width: 230px;
        height: 80px;
        background: url(~@/assets/img/go_luck.png)no-repeat;
        background-size: 100% 100%;
      }
    }
    .dialog_light{
      width: 100%;
      height: 100%;
      padding: 123px 75px 102px 86px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      p{
        font-size: 38px;
        color: #3F1F07;
        line-height: 50px;
        text-align: center;
        white-space: nowrap;
      }
      .know_btn{
        width: 230px;
        height: 80px;
        background: url(~@/assets/img/know.png)no-repeat;
        background-size: 100% 100%;
      }
    }
    .dialog_rule{
      width: 100%;
      height: 100%;
      padding: 89px 100px 82px 111px;
      h1{
        line-height: 66px;
        font-size: 50px;
        color: #FF731F;
        text-align: center;
      }
      p{
        font-size: 34px;
        color: #3F1F07;
        margin-top: 10px;
      }
    }
  }
}
.status_bar{
  width: 100%;
  height: 104px;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 85px;
  padding: 0 38px;
  z-index: 1;
  div{
    width: 104px;
    height: 104px;
    &:last-child{
      display: flex;
      flex-direction: column;
    }
    img{
      width: 104px;
      height: 104px;
    }
    .rule_btn{
      width: 104px;
      height: 117px;
    }
  }
}
.point_body{
  width: 103px;
  height: 126px;
  position: absolute;
  right: 75px;
  bottom: 722px;
  pointer-events: none;
  &.point_body_animation{
    .point_box{
      animation: jello-horizontal 0.4s both infinite,animation_down .8s linear infinite;
    }
    &>em{
      animation: scale_animation .8s infinite linear;
    }
  }
  &.point_body_shan_animation{
    &>.point_box{
      div{
        position: relative;
        &::before{
          content: '';
          width: 20px;
          height: 100px;
          background: rgba(255, 255, 255, .6);
          position: absolute;
          left: 0;
          animation: shan_animation 2s infinite;
        }
      }
    }
  }
  &.xhn_point{
    left: 76%;
    top: 35%;
    transform: translate(-50%,-100%);
  }
  &.why_point{
      left: 27%;
      top: 55%;
      transform: translate(-50%,-100%);
  }
  &.exhibition_point{
    left: 39%;
    bottom: 5%;
    transform: translate(-50%, -100%);
  }
  &.grugs_point{
    right: 8%;
    bottom: 20%;
    transform: translate(-50%,-100%);
  }
  &.paddy_point{
    right: 5%;
    bottom: 20%;
    transform: translate(-50%,-100%);
  }
  &>em{
    width: 74px;
    height: 21px;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -37px;
    background: url(~@/assets/img/mark_shaow.png)no-repeat;
    background-size: 100% 100%;
  }
}
.point_box{
  width: 103px;
  height: 116px;
  background: url(~@/assets/img/mark.png)no-repeat;
  background-size: 100% 100%;
  position: relative;
  z-index: 1;
  div{
    width: 74px;
    height: 74px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 10%;
    border-radius: 100%;
    overflow: hidden;
    img{
      width: 67px;
      height: 67px;
      border-radius: 100%;
      object-fit: cover;
    }
  }
}
.home{
  width: 100%;
  height: 100vh;
  background: rgb(131,194,107);
  .mark_box{
    width: 100%;
    position: relative;
    &>.bg{
      display: block;
      width: 100%;
    }
    .light_btn_body{
      width: 201px;
      height: 96px;
      position: absolute;
      bottom: -88px;
      left: 50%;
      transform: translateX(-50%);
      &.light_btn_exhibition{
        left: 70%;
        bottom: 50px;
      }
      &.light_btn_grugs{
        left: 60%;
        bottom: -30px;
      }
      &.light_btn_paddy{
        bottom: -70px;
      }
      .ca_box{
        width: 180px;
        height: 76px;
        position: absolute;
        left: 50%;
        top:46%;
        transform: translate(-50%,-50%);
        overflow: hidden;
        border-radius: 38px;
        &::before{
          content: '';
          width: 20px;
          height: 100px;
          background: rgba(255, 255, 255, .6);
          position: absolute;
          left: 0;
          animation: shan_animation2 4s infinite;
        }
      }
      img{
        width: 100%;
        height: 100%;
      }
      &.xhn_light_btn{
          transform: translateX(-65%);
        }
    }
    .join_btn_body{
      width: 201px;
      height: 96px;
      position: absolute;
      bottom: -102px;
      left: 50%;
      transform: translateX(-50%);
      &.light_btn_exhibition{
        left: 70%;
        bottom: 50px;
      }
      &.light_btn_grugs{
        left: 60%;
        bottom: -30px;
      }
      .join_btn{
        width: 100%;
        height: 100%; 
      }
      &.xhn_join_btn{
          transform: translateX(-70%);
      }
      &.light_btn_paddy{
        bottom: -70px;
      }
      .ca_box{
        width: 220px;
        height: 76px;
        position: absolute;
        left: 50%;
        top:50%;
        transform: translate(-50%,-50%);
        overflow: hidden;
        border-radius: 38px;
        &::before{
          content: '';
          width: 20px;
          height: 100px;
          background: rgba(255, 255, 255, .6);
          position: absolute;
          left: 0;
          animation: shan_animation2 4s infinite;
        }
      }
    }
    .xhn_build{
      width: 369px;
      height: 481px;
      // background: url(~@/assets/img/xhn_hui.png)no-repeat;
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      top: 12%;
      .xhn_build_img{
        width: 100%;
        height: 100%;
        &.duang_animation{
          animation: jello-horizontal 1s both;
        }
      }
      // &.xhn_build_light{
      //   background: url(~@/assets/img/xhn.png)no-repeat;
      //   background-size: 100% 100%;
      // }
    }
    .why_build{
      width: 260px;
      height: 566px;
      background-size: 100% 100%;
      position: absolute;
      left: 5%;
      top: 26%;
      .why_build_img{
        width: 100%;
        height: 100%;
        &.duang_animation{
          animation: jello-horizontal 1s both;
        }
      }
      // &.why_build_light{
      //   background: url(~@/assets/img/why.png)no-repeat;
      //   background-size: 100% 100%;
      // }
    }
    .exhibition_build{
      width: 495px;
      height: 330px;
      background-size: 100% 100%;
      position: absolute;
      left: 4%;
      bottom: 3%;
      .exhibition_build_img{
        width: 100%;
        height: 100%;
        &.duang_animation{
          animation: jello-horizontal 1s both;
        }
      }
    }
    .paddy_build{
      width: 338px;
      height: 318px;
      background-size: 100% 100%;
      position: absolute;
      right: 0%;
      bottom: 19%;
      .paddy_build_img{
        width: 100%;
        height: 100%;
        &.duang_animation{
          animation: jello-horizontal 1s both;
        }
      }
    }
    .grugs_build{
      width: 298px;
      height: 383px;
      background-size: 100% 100%;
      position: absolute;
      right: 0%;
      bottom: 21%;
      .grugs_build_img{
        width: 100%;
        height: 100%;
        &.duang_animation{
          animation: jello-horizontal 1s both;
        }
      }
    }
  }
}
</style>
